import { Link, Typography } from '@/components';
import { NotificationDetail } from '../../types';

interface BaseNotificationMessageProps {
  notification: NotificationDetail;
  children: React.ReactNode;
}

export function BaseNotificationMessage({ notification, children }: BaseNotificationMessageProps) {
  const fontWeight = !notification.isRead ? 'font-medium' : 'font-normal';

  return (
    <Typography
      as="p"
      size="body-3"
      color="secondary"
      weight="normal"
      align="left"
      className={`leading-relaxed ${fontWeight}`}
    >
      {children}
    </Typography>
  );
}

interface NotificationLinkProps {
  to?: string;
  children: React.ReactNode;
}

export function NotificationLink({ to, children }: NotificationLinkProps) {
  if (!to) return <span>{children}</span>;

  return (
    <Link to={to} target="_blank" className="text-black">
      {children}
    </Link>
  );
}
